module.exports = "/_next/static/images/8a100163c02298d66c7f292b6d1711aa-card-md.png";